import { Button, Card, Typography, theme } from "antd";
import { HomeOutlined } from "@ant-design/icons";
import { useTheme } from "../../contexts/ThemeContext";
import useOrg from "../../hooks/apis/useOrg";
import Loading from "../../components/loading";
import Error from "../../components/error";
import PhoneLoginButton from "../../components/Auth/PhoneLogin";
import { IS_WHITE_LABEL } from "../../constants";

function Login() {
  const { data: org, isLoading: orgLoading, error: orgError } = useOrg();
  const {
    token: {
      colorBgContainer,
      colorTextSecondary,
      colorPrimary,
      colorPrimaryActive,
      colorBgLayout,
      colorLink,
    },
  } = theme.useToken();
  const { isDark } = useTheme();
  if (orgLoading) return <Loading size="screen" />;
  if (orgError) return <Error size="screen" />;
  const isWhiteLabel = org?.config?.whiteLabel ?? IS_WHITE_LABEL;
  const logo = isDark ? org?.theme.logoDark || org?.theme.logo : org?.theme.logo;
  const brandLogo = org?.theme.logoDark || logo;

  const loginCard = (
      <Card
        className={`w-full max-w-md shadow-none border-0 login-card ${
          isWhiteLabel ? "" : "md:shadow-xl"
        }`}
        style={{
          backgroundColor: "transparent",
          borderRadius: "24px",
          padding: "32px 24px",
        }}
      >
        {!isWhiteLabel && (
          <style>{`
            @media (min-width: 768px) {
              .login-card {
                background-color: ${colorBgContainer} !important;
              }
            }
          `}</style>
        )}
        {/* Logo */}
        <div className={`w-full justify-center ${isWhiteLabel ? "flex md:hidden" : "flex"}`}>
          {logo ? (
            <img
              src={logo}
              alt={`${org!.theme.title || org!.title} logo`}
              className="mx-auto"
              style={{ height: 48, marginBottom: 8 }}
            />
          ) : (
            <Typography.Title level={2}>{org!.theme.title || org!.title}</Typography.Title>
          )}
        </div>
        {/* Login Methods */}
        <div className="w-full flex justify-center">
          <PhoneLoginButton />
        </div>
        {/* Terms and Return */}

        {/* Terms and Return */}
        <div className="w-full flex flex-col items-center gap-2 mt-4">
          {org!.tos && (
            <Typography.Paragraph
              className="text-center"
              style={{
                color: colorTextSecondary,
                fontSize: 13,
                marginBottom: 0,
              }}
            >
              با ورود،{" "}
              <a
                href={org!.tos}
                target="_blank"
                rel="noreferrer"
                style={{ color: colorLink || colorPrimary }}
              >
                شرایط استفاده
              </a>{" "}
              را می‌پذیرید.
            </Typography.Paragraph>
          )}
          {org!.website && (
            <Button
              type="link"
              href={org!.website}
              icon={<HomeOutlined />}
              style={{ color: colorTextSecondary, fontSize: 15 }}
            >
              بازگشت به سایت
            </Button>
          )}
        </div>
      </Card>
  );

  if (isWhiteLabel) {
    return (
      <div className="min-h-screen w-full grid md:grid-cols-2" dir="ltr">
        <section
          className="relative hidden md:flex items-center justify-center overflow-hidden"
          style={{
            minHeight: "100vh",
            background: `linear-gradient(145deg, ${colorPrimary}, ${colorPrimaryActive})`,
          }}
        >
          {brandLogo ? (
            <>
              <img
                aria-hidden
                src={brandLogo}
                alt=""
                className="absolute w-3/4 max-w-2xl opacity-30 blur-[48px] scale-125"
              />
              <img
                src={brandLogo}
                alt={`${org!.theme.title || org!.title} logo`}
                className="relative w-3/5 max-h-52 object-contain drop-shadow-2xl"
              />
            </>
          ) : (
            <Typography.Title level={1} style={{ color: "white" }}>
              {org!.theme.title || org!.title}
            </Typography.Title>
          )}
        </section>
        <main
          className="min-h-screen flex items-center justify-center px-4"
          dir="rtl"
          style={{ backgroundColor: colorBgContainer }}
        >
          {loginCard}
        </main>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen w-full flex items-center justify-center"
      style={{ minHeight: "100vh", backgroundColor: colorBgLayout }}
    >
      {loginCard}
    </div>
  );
}

export default Login;
